// MWDH Theme - Umbraco Project JavaScript
// Import base MWDH theme functionality
// Base MWDH theme functionality is loaded via the main js/app.js file

// Umbraco-specific JavaScript functionality
console.log('MWDH Umbraco theme JavaScript loaded');

// Add any Umbraco-specific JavaScript here
// Example: Umbraco grid customizations, form enhancements, etc.
